module.exports = __webpack_public_path__ + "static/crane-dd7ed4b85aa5d6548cfb87510b8572b4.svg";